// Keep one SDK/service instance, including when restore and UI actions overlap.
export default class LazyWallet<T> {
    current: T | undefined;
    private pending: Promise<T> | undefined;

    constructor(private readonly create: () => Promise<T>) {}

    load(): Promise<T> {
        if (this.current) {
            return Promise.resolve(this.current);
        }
        if (!this.pending) {
            this.pending = this.create()
                .then(client => {
                    this.current = client;
                    return client;
                })
                .catch(error => {
                    // A failed chunk request must not poison subsequent connection attempts.
                    this.pending = undefined;
                    throw error;
                });
        }
        return this.pending;
    }
}
